import React, { useState } from 'react';
import {
    Dialog, DialogActions, DialogContent, DialogTitle,
    Button, Typography, Alert, Box
} from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';

export default function RestoreHotelModal({ open, onClose, onSave, hotel }) {
    const [isRestoring, setIsRestoring] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        setIsRestoring(true);
        setError(null);
        try {
            await onSave({
                id: hotel.id,
                tenantId: hotel.tenantId,
            });
            onClose();
        } catch (err) {
            setError(err?.response?.data?.message || err?.message || 'Failed to restore hotel');
        } finally {
            setIsRestoring(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={isRestoring ? undefined : onClose}
            PaperProps={{ sx: { borderRadius: 3, padding: 1, minWidth: 440 } }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 'bold' }}>
                <RestoreIcon color="success" /> Restore Hotel
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>
                    {hotel && (
                        <Alert severity="info" sx={{ borderRadius: 2 }}>
                            Are you sure you want to restore <strong>{hotel.name}</strong>? This will bring the property back online and make it available in the active property switcher layout.
                        </Alert>
                    )}
                    {error && (
                        <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert>
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: '0 24px 16px 24px' }}>
                <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }} disabled={isRestoring}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    sx={{ borderRadius: 2 }}
                    disabled={isRestoring}
                >
                    {isRestoring ? 'Restoring...' : 'Restore'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
